/**
 * PMS web 版本更新提示
 * 根据构建时生成的manifest信息比对
 */
import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'antd';
import Axios from 'axios';

import { format2TimeStamp } from '@/utils/date';
import { renderIntlLabel } from '@/utils';
import styles from './index.module.scss';

interface DeployInfo {
  deployTime: number;
  deployHash: number;
}

const maskStyle = { zIndex: 9998 };

export default () => {
  const [visible, setVisible] = useState(false);
  const currentVersion = useRef<DeployInfo>(null);

  const getRemoteVersion: () => Promise<DeployInfo> = () => {
    return Axios.get(`/asset-manifest.json?v=${format2TimeStamp()}`).then(
      (res) => {
        const resData = res ? res.data : null;
        if (resData && resData.deployTime) {
          return {
            deployTime: resData.deployTime,
            deployHash: resData.deployHash,
          };
        }
        return null;
      },
      () => null,
    );
  };

  const refreshRemoteVersion = () => {
    setTimeout(() => {
      getRemoteVersion().then((versionInfo) => {
        const prevVersion = currentVersion.current;
        if (versionInfo && prevVersion && versionInfo.deployTime > prevVersion.deployTime) {
          setVisible(true);
        } else {
          refreshRemoteVersion();
        }
      });
    }, 10 * 60 * 1000);
  };

  const handleCancelClick = () => {
    setVisible(false);
    refreshRemoteVersion();
  };

  const handleConfirmClick = () => {
    window.location.reload();
  };

  useEffect(() => {
    getRemoteVersion().then((versionInfo) => {
      if (versionInfo) {
        currentVersion.current = versionInfo;
        refreshRemoteVersion();
      }
    });
  }, []);

  return (
    <Modal
      visible={visible}
      title={renderIntlLabel('app_new_version')}
      centered
      maskClosable={false}
      closable={false}
      cancelText={renderIntlLabel('app_remind_after_some_minutes', { minutes: 10 })}
      okText={renderIntlLabel('app_btn_refresh_immediately')}
      wrapClassName={styles.updatePromptModal}
      maskStyle={maskStyle}
      onCancel={handleCancelClick}
      onOk={handleConfirmClick}
    >
      {renderIntlLabel('app_tips_of_updated_version')}
    </Modal>
  );
};
